import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { DocumentLinksQuery, DocumentLinksQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(DocumentLinksQuery)
@Wrapper(DocumentLinksQueryHandlerBase)
export class DocumentLinksQueryHandler {
    public constructor(
        http: Http
    ) { }
}
